export type OrderStatus = 'yeni' | 'hazirlaniyor' | 'hazir';

export interface OrderItem {
  id: string;
  name: string;
  size: string;
  milk: string;
  syrup: string;
  extraShot: boolean;
  quantity: number;
}

export interface BaristaOrder {
  id: string;
  orderNumber: string;
  customerName: string;
  customerInitials: string;
  status: OrderStatus;
  items: OrderItem[];
  notes: string;
  orderType: 'gel-al' | 'masa';
  tableNumber?: string;
  createdAt: string;
  elapsedMinutes: number;
  totalPrice: number;
}

export const initialOrders: BaristaOrder[] = [
  {
    id: 'bord-1042',
    orderNumber: '#1042',
    customerName: 'Ayşe K.',
    customerInitials: 'AK',
    status: 'yeni',
    items: [
      { id: 'oi-1042-1', name: 'Caramel Latte', size: 'Grande', milk: 'Yulaf Sütü', syrup: 'Karamel', extraShot: false, quantity: 1 },
      { id: 'oi-1042-2', name: 'Tereyağlı Kruvasan', size: '-', milk: '-', syrup: '-', extraShot: false, quantity: 1 },
    ],
    notes: 'Az karamel, lütfen',
    orderType: 'gel-al',
    createdAt: '09:12',
    elapsedMinutes: 2,
    totalPrice: 134,
  },
  {
    id: 'bord-1043',
    orderNumber: '#1043',
    customerName: 'Mehmet Y.',
    customerInitials: 'MY',
    status: 'yeni',
    items: [
      { id: 'oi-1043-1', name: 'Hazelnut Latte', size: 'Venti', milk: 'Tam Yağlı Süt', syrup: 'Fındık', extraShot: true, quantity: 1 },
    ],
    notes: '',
    orderType: 'masa',
    tableNumber: '7',
    createdAt: '09:14',
    elapsedMinutes: 1,
    totalPrice: 103,
  },
  {
    id: 'bord-1044',
    orderNumber: '#1044',
    customerName: 'Zeynep A.',
    customerInitials: 'ZA',
    status: 'hazirlaniyor',
    items: [
      { id: 'oi-1044-1', name: 'Caramel Chiller', size: 'Grande', milk: 'Soya Sütü', syrup: 'Karamel', extraShot: false, quantity: 1 },
      { id: 'oi-1044-2', name: 'Cheesecake Dilimi', size: '-', milk: '-', syrup: '-', extraShot: false, quantity: 1 },
    ],
    notes: 'Gluten hassasiyeti yok, ama laktoz intoleransı var',
    orderType: 'gel-al',
    createdAt: '09:10',
    elapsedMinutes: 5,
    totalPrice: 164,
  },
  {
    id: 'bord-1045',
    orderNumber: '#1045',
    customerName: 'Can B.',
    customerInitials: 'CB',
    status: 'hazirlaniyor',
    items: [
      { id: 'oi-1045-1', name: 'Americano', size: 'Tall', milk: 'Sütsüz', syrup: 'Yok', extraShot: true, quantity: 2 },
    ],
    notes: 'Çok sıcak olsun',
    orderType: 'masa',
    tableNumber: '3',
    createdAt: '09:08',
    elapsedMinutes: 7,
    totalPrice: 164,
  },
  {
    id: 'bord-1041',
    orderNumber: '#1041',
    customerName: 'Elif D.',
    customerInitials: 'ED',
    status: 'hazir',
    items: [
      { id: 'oi-1041-1', name: 'Hazelnut Chiller', size: 'Grande', milk: 'Badem Sütü', syrup: 'Yok', extraShot: false, quantity: 1 },
    ],
    notes: '',
    orderType: 'gel-al',
    createdAt: '09:05',
    elapsedMinutes: 10,
    totalPrice: 99,
  },
  {
    id: 'bord-1040',
    orderNumber: '#1040',
    customerName: 'Burak T.',
    customerInitials: 'BT',
    status: 'hazir',
    items: [
      { id: 'oi-1040-1', name: 'Cold Brew', size: 'Venti', milk: 'Sütsüz', syrup: 'Vanilya', extraShot: false, quantity: 1 },
      { id: 'oi-1040-2', name: 'Sezonluk Baharatlı Latte', size: 'Tall', milk: 'Tam Yağlı Süt', syrup: 'Yok', extraShot: false, quantity: 1 },
    ],
    notes: '',
    orderType: 'masa',
    tableNumber: '12',
    createdAt: '09:03',
    elapsedMinutes: 12,
    totalPrice: 174,
  },
];